import { render } from "./ProgSocialEdit.vue?vue&type=template&id=27cc92a6"
import script from "./ProgSocialEdit.vue?vue&type=script&lang=js"
export * from "./ProgSocialEdit.vue?vue&type=script&lang=js"

import "./ProgSocialEdit.vue?vue&type=style&index=0&id=27cc92a6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__